import {useRequestHeaders} from "#app";
import { containsSubstring } from './index';

export function getCurrentLanguages(){
    let lang = useCookie('lang').value
    if (!lang) {
        const acceptLanguage = useRequestHeaders(['accept-language'])['accept-language']
        if (acceptLanguage) {
            let acceptFirst = acceptLanguage.split(";")[0].split(",")[0]
            if (containsSubstring(acceptFirst, 'zh')) {
                lang = 'zh'
            }else {
                lang = acceptFirst
            }
            const checkLanguages = ["zh", "ja", 'en', "ko", "tw", "hi", "ar", "de", "fr", "id", "itb","uk"]
            let currents = checkLanguages.find((item)=>{ return item === lang }) || []
            if (currents.length === 0) {
                lang = null
            }
        }
    }
    return lang || "en"
}
